'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Application theme details.
 *
 * @export
 * @interface AppTheme
 */

// Theme settings.
var THEMES = [{
  href: 'light.css',
  accent: '#009688',
  primary: '#ef6c00',
  isDark: false,
  isDefault: false
}, {
  href: 'dark.css',
  accent: '#009688',
  primary: '#ef6c00',
  isDark: true,
  isDefault: true
}];

exports.THEMES = THEMES;
